<div class="main-card">
  <div class="header-row">
    <a
      class="back-btn"
      [routerLink]="[URL_SOURCE ? URL_SOURCE : '/']"
      title="بازگشت"
    >
      <i class="fa fa-arrow-right"></i> بازگشت
    </a>
    <div class="top-bar">
      <div class="greeting">
        <i class="fa fa-car"></i>
        <h1>داشبورد متحرک <small>· مدیریت یکپارچه</small></h1>
      </div>
      <div class="status-chip" *ngIf="car" [class.off]="!car.bOnline">
        <i class="fa fa-circle"></i> {{ car.bOnline ? "آنلاین" : "آفلاین" }} ·
        لاگ: {{ car.strDate | faNum }}
      </div>
      <div class="status-chip" *ngIf="!car">
        <i class="fa fa-circle" style="color: #94a3b8"></i> در حال بارگذاری...
      </div>
    </div>
  </div>

  <ng-container *ngIf="car">
    <div class="two-col">
      <div class="info-panel">
        <div class="vehicle-head">
          <div class="vehicle-title">
            <div class="name-plate-row">
              <h2>
                {{ car.strFullName || "—" }}
                <span
                  style="font-weight: 400; font-size: 16px; color: #2f5683"
                  >{{ car.strVehicleType }}</span
                >
              </h2>
              <div class="license-plate" *ngIf="car.tiPlateType != 10">
                <div class="blue-column">
                  <div class="flag">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                  <div class="text">
                    <div>I.R.</div>
                    <div>IRAN</div>
                  </div>
                </div>
                <span>{{ car.plak[0] | faNum }}</span>
                <span class="alphabet-column">{{ car.plak[1] | faNum }}</span>
                <span>{{ car.plak[2] | faNum }}</span>
                <div class="iran-column">
                  <span>ایــران</span><strong>{{ car.plak[4] | faNum }}</strong>
                </div>
              </div>
              <div *ngIf="car.tiPlateType == 10">
                <b>{{ (car.strPersonnelID ?? '') | faNum }}</b>
              </div>
            </div>
            <div class="meta">
              <span
                ><i class="fa fa-tag" style="color: #7c3aed"></i>
                {{ car.strMobileType_strComment || "نامشخص" }}
              </span>
              <span
                ><i class="fa fa-road" style="color: #059669"></i>
                {{ car.iSpeed | faNum }} کیلومتر/ساعت</span
              >
              <span
                ><i class="fa fa-clock-o" style="color: #d97706"></i> ساعت
                کارکرد: {{ car.iDurationOfOperation | faNum }}h</span
              >
            </div>
          </div>
        </div>

        <div class="info-grid-3col">
          <div class="info-item" *ngIf="car.bTanker == 1">
            <span class="label">نوع تانکر</span>
            <span class="value"
              ><i class="fa fa-tint"></i>
              {{ car.strMaterialType_strComment || "—" }}</span
            >
          </div>
          <div class="info-item" *ngIf="car.bTanker == 1">
            <span class="label">حجم مخزن</span>
            <span class="value"
              ><i class="fa fa-flask"></i> {{ car.fVolume | faNum }} لیتر</span
            >
          </div>
          <div class="info-item" *ngIf="car.bTanker == 1">
            <span class="label">ظرفیت موجود</span>
            <span class="value" title="وزن کل - سنسور وزن"
              ><i class="fa fa-balance-scale"></i>
              {{ car.fCapacity | faNum }} لیتر</span
            >
          </div>
          <div class="info-item">
            <span class="label">پیمایش امروز</span>
            <span class="value"
              ><i class="fa fa-road"></i>
              {{ otherService.getSeparatedValue(car.fDistanceTraveled) }}
              کیلومتر</span
            >
          </div>
          <div class="info-item">
            <span class="label">حداکثر سرعت امروز</span>
            <span class="value"
              ><i class="fa fa-tachometer"></i>
              {{ car.iMaxSpeedToday | faNum }} کیلومتر/ساعت</span
            >
          </div>
          <div class="info-item">
            <span class="label">سرعت متوسط امروز</span>
            <span class="value"
              ><i class="fa fa-line-chart"></i>
              {{
                car.iAverageSpeedToday
                  ? (car.iAverageSpeedToday | faNum) + " کیلومتر/ساعت"
                  : "—"
              }}</span
            >
          </div>
        </div>

        <div class="info-grid-3col">
          <div class="info-item">
            <span class="label">موبایل مالک</span>
            <span class="value">
              <i class="fa fa-user"></i>
              {{ car.strMobile ? (car.strMobile | faNum) : '—' }}
            </span>
          </div>
          <div class="info-item">
            <span class="label">شماره سیم کارت</span>
            <span class="value">
              <i class="fa fa-mobile"></i>
              {{ car.strCellNo ? (car.strCellNo | faNum) : '—' }}
            </span>
          </div>
          <div class="info-item">
            <span class="label">کیلومتر فعلی</span>
            <span class="value"
              ><i class="fa fa-dashboard"></i>
              {{ otherService.getSeparatedValue(car.fLastKM) }} کیلومتر</span
            >
          </div>
        </div>

        <hr class="info-divider" />

        <div class="info-grid-3col">
          <div class="info-item">
            <span class="label">مدت آخرین توقف</span>
            <span class="value"><i class="fa fa-pause-circle"></i> —</span>
          </div>
          <div class="info-item" style="grid-column: span 1">
            <span class="label">آدرس آخرین توقف</span>
            <span class="value" style="font-size: 12px"
              ><i class="fa fa-map-marker"></i> {{ "—" }}</span
            >
          </div>
          <div class="info-item">
            <span class="label">پایان اعتبار</span>
            <span class="value"
              ><i class="fa fa-calendar"></i>
              {{ car.strValidDate | faNum }}</span
            >
          </div>
        </div>
      </div>
      <div class="status-panel">
        <div class="status-header">
          <h3><i class="fa fa-cogs"></i> وضعیت لحظه‌ای</h3>
          <span class="online-tag" [class.off]="!car.bOnline"
            ><i class="fa fa-circle"></i>
            {{ car.bOnline ? "زنده" : "آفلاین" }}</span
          >
        </div>

        <div class="io-wrapper">
          <div class="io-cell">
            <div class="io-label"><i class="fa fa-bolt"></i> ولتاژ</div>
            <div class="io-val">{{ car.fPower | faNum }} <small>V</small></div>
            <div
              class="ci-state"
              style="font-size: 10px"
              [ngClass]="getSensorState('voltage').cls"
            >
              {{ getSensorState("voltage").label }}
            </div>
          </div>
          <div class="io-cell" *ngIf="car.bTemperatureSensor == 1">
            <div class="io-label">
              <i class="fa fa-thermometer-half"></i> دما
            </div>
            <div class="io-val">
              {{ car.iTemperature | faNum }} <small>°C</small>
            </div>
            <div
              class="ci-state"
              style="font-size: 10px"
              [ngClass]="getSensorState('temp').cls"
            >
              {{ getSensorState("temp").label }}
            </div>
          </div>
          <div class="io-cell" *ngIf="car.bTanker == 1">
            <div class="io-label"><i class="fa fa-tint"></i> مایع موجود</div>
            <div class="io-val">
              {{ car.fVolume | faNum }} <small>لیتر</small>
            </div>
            <div
              class="ci-state"
              style="font-size: 10px"
              [ngClass]="getSensorState('volume').cls"
            >
              {{ getSensorState("volume").label }}
            </div>
          </div>
          <div class="io-cell" *ngIf="car.bFuelSensor">
            <div class="io-label"><i class="fa fa-tint"></i> سوخت</div>
            <div class="io-val">{{ car.iFuel | faNum }} <small>L</small></div>
            <div
              class="ci-state"
              style="font-size: 10px"
              [ngClass]="getSensorState('fuel').cls"
            >
              {{ getSensorState("fuel").label }}
            </div>
          </div>
          <div class="io-cell" *ngIf="car.bWeightSensor == 1">
            <div class="io-label"><i class="fa fa-balance-scale"></i> وزن</div>
            <div class="io-val">
              {{ car.fWeight | faNum }} <small>kg</small>
            </div>
            <div
              class="ci-state"
              style="font-size: 10px"
              [ngClass]="getSensorState('weight').cls"
            >
              {{ getSensorState("weight").label }}
            </div>
          </div>
          <div class="io-cell">
            <div class="io-label"><i class="fa fa-battery-3"></i> باتری</div>
            <div class="io-val">
              {{ car.fBattery | faNum }} <small>%</small>
            </div>
            <div
              class="ci-state"
              style="font-size: 10px"
              [ngClass]="getSensorState('battery').cls"
            >
              {{ getSensorState("battery").label }}
            </div>
          </div>
        </div>

                <div class="location-row">
          <span class="log-row"
            ><span class="log-label"><i class="fa fa-clock-o"></i> آخرین لاگ:</span
            ><span class="log-date">{{ (car.strTimeAge || "—") | faNum }}</span></span
          >
          <span
            ><i class="fa fa-map-marker"></i> موقعیت:
            {{ car.strAddress || "—" }}</span
          >
        </div>
      </div>
    </div>
    <div class="section-label" *ngIf="car" style="margin-top: 10px">
      <i class="fa fa-bolt"></i> دسترسی سریع
    </div>
        <div class="action-row" *ngIf="car">
      <a class="btn-soft btn-route" data-bs-toggle="modal" data-bs-target="#exampleModal" [ngClass]="showLocation ? 'index-1' : ''"><i class="fa fa-road"></i> مسیر</a>
      <a class="btn-soft btn-track" [routerLink]="['/tracker/', Id]" [ngClass]="showLocation ? 'index-1' : ''"><i class="fa fa-map-marker"></i> موقعیت‌یابی</a>
      <a class="btn-soft btn-camera" *ngIf="car.bDashCam" (click)="checkOutOnline_Status()"><i class="fa fa-video-camera"></i> نظارت تصویری</a>
      <a class="btn-soft btn-work" *ngIf="acssess.bReportDaily" data-bs-toggle="modal" data-bs-target="#exampleModal4"><i class="fa fa-bar-chart"></i> گزارش کارکرد</a>
      <a class="btn-soft btn-stop" *ngIf="acssess.bReportStop" data-bs-toggle="modal" data-bs-target="#exampleModal3"><i class="fa fa-pause-circle"></i> توقف</a>
      <a class="btn-soft btn-route" *ngIf="acssess.bRouting" (click)="openMap()"><i class="fa fa-location-arrow"></i> مسیریابی</a>
      <a class="btn-soft btn-edit" *ngIf="acssess.bEnableEditCar" (click)="hasGps ? saveCar(1) : saveCar(2)"><i class="fa fa-pencil"></i> ویرایش</a>
      <a class="btn-soft btn-edit" *ngIf="!acssess.bEnableEditCar" (click)="hasGps ? saveCar(1) : saveCar(2)"><i class="fa fa-info-circle"></i> اطلاعات کامل</a>
    </div><hr *ngIf="car" />
    <div class="section-label" *ngIf="car">
      <i class="fa fa-compass"></i> عملیات و گزارش‌های اختصاصی
    </div>

        <div class="op-grid" *ngIf="car">
      <a class="op-item op-report" (click)="reportModal.open()"><i class="fa fa-pie-chart"></i> گزارش</a>
      <a class="op-item op-area" (click)="operationModal.open()" [ngClass]="showLocation ? 'index-1' : ''"><i class="fa fa-folder-open"></i> عملیات <span class="counter"></span></a>
      <a class="op-item op-delivery" *ngIf="acssess.bTransformation" [routerLink]="['/transformation/', Id]"><i class="fa fa-exchange"></i> تحویل و تحول</a>
      <a class="op-item op-fuel" *ngIf="acssess.bRefueling" [routerLink]="['/refule/', Id]"><i class="fa fa-tint"></i> سوخت‌گیری <span class="counter"></span></a>
      <a class="op-item op-area" *ngIf="acssess.bDefGeoFance" [routerLink]="['/carArea/', Id]" [ngClass]="showLocation ? 'index-1' : ''"><i class="fa fa-th"></i> محدوده‌ها</a>
      <a class="op-item op-diag" *ngIf="car.bOBD2" [routerLink]="['/fleetdiag/', Id, 'workspace']"><i class="fa fa-cogs"></i> دیاگ موتور <span class="counter"></span></a>
      <a class="op-item op-can1" *ngIf="car.bOBD2" [routerLink]="['/can/', Id, 'basic-info']"><i class="fa fa-plug"></i> CAN پایه</a>
      <a class="op-item op-can2" *ngIf="car.bOBD2" [routerLink]="['/can/', Id, 'full-info']"><i class="fa fa-sitemap"></i> CAN جامع</a>
      <a class="op-item op-support" *ngIf="acssess.bEnableTiket" [routerLink]="['/support/', Id]"><i class="fa fa-headphones"></i> پشتیبانی</a>
      <a class="op-item op-docs" (click)="openDocumentModal()"><i class="fa fa-file-text"></i> اسناد</a>
      <a class="op-item op-income" *ngIf="acssess.bEnableCarRvenues" [routerLink]="['/income/', Id]"><i class="fa fa-money"></i> درآمد</a>
      <a class="op-item op-cmd" *ngIf="acssess.bEnableCommand" data-bs-toggle="modal" data-bs-target="#exampleModal6" (click)="updateCommand(true)" [ngClass]="showLocation ? 'index-1' : ''"><i class="fa fa-paper-plane"></i> ارسال فرمان</a>
    </div>
  </ng-container>

  <div *ngIf="!car" style="text-align: center; padding: 40px; color: #64748b">
    <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
    <p style="margin-top: 10px">در حال بارگذاری اطلاعات متحرک...</p>
  </div>
</div>

<div
  class="modal fade rtl"
  id="exampleModal"
  tabindex="-1"
  aria-labelledby=""
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-clock-o me-2"></i>انتخاب تاریخ
        </h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div class="chip-group">
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('datasabt', 'today')"
            (click)="setQuickDate('datasabt', 'today')"
          >
            امروز
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('datasabt', 'yesterday')"
            (click)="setQuickDate('datasabt', 'yesterday')"
          >
            دیروز
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('datasabt', 'weekStart')"
            (click)="setQuickDate('datasabt', 'weekStart')"
          >
            شروع هفته
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('datasabt', 'monthStart')"
            (click)="setQuickDate('datasabt', 'monthStart')"
          >
            شروع ماه
          </button>
        </div>

        <div class="row g-3">
          <div class="col-md-4">
            <div class="range-input">
              <span class="range-label">تاریخ *</span>
              <form [formGroup]="datasabt">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="date"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>

          <div class="col-md-4">
            <div class="range-input">
              <span class="range-label">از ساعت *</span>
              <div class="input-group clockpicker">
                <input
                  type="text"
                  class="form-control"
                  value="00:00"
                  id="StimeR"
                  readonly
                />
                <span class="input-group-addon">
                  <span class="glyphicon glyphicon-time"></span>
                </span>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="range-input">
              <span class="range-label">تا ساعت *</span>
              <div class="input-group clockpicker">
                <input
                  type="text"
                  class="form-control"
                  value="23:59"
                  id="EtimeR"
                  readonly
                />
                <span class="input-group-addon">
                  <span class="glyphicon glyphicon-time"></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          بستن
        </button>
        <button type="button" class="btn btn-primary" (click)="sabt()">
          تایید
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade rtl"
  id="exampleModal3"
  tabindex="-1"
  aria-labelledby=""
  aria-hidden="true"
  data-backdrop="false"
  data-bs-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-clock-o me-2"></i>بازه مد نظر خود را انتخاب کنید
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="bTankerMood = false"
        ></button>
      </div>
      <div class="modal-body">
        <div class="chip-group">
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('datasabtStop', 'today')"
            (click)="setQuickDate('datasabtStop', 'today', 'date', 'strEDate')"
          >
            امروز
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('datasabtStop', 'yesterday')"
            (click)="
              setQuickDate('datasabtStop', 'yesterday', 'date', 'strEDate')
            "
          >
            دیروز
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('datasabtStop', 'weekStart')"
            (click)="
              setQuickDate('datasabtStop', 'weekStart', 'date', 'strEDate')
            "
          >
            شروع هفته
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('datasabtStop', 'monthStart')"
            (click)="
              setQuickDate('datasabtStop', 'monthStart', 'date', 'strEDate')
            "
          >
            شروع ماه
          </button>
        </div>

        <div class="row g-3">
          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">{{
                bTankerMood ? "از تاریخ *" : "تاریخ *"
              }}</span>
              <form [formGroup]="datasabtStop">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="date"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>

          <div class="col-md-6" *ngIf="bTankerMood">
            <div class="range-input">
              <span class="range-label">تا تاریخ *</span>
              <form [formGroup]="datasabtStop">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="strEDate"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>

          <ng-container *ngIf="!bTankerMood">
            <div class="col-md-3">
              <div class="range-input">
                <span class="range-label">از ساعت *</span>
                <div class="input-group clockpicker">
                  <input
                    type="text"
                    class="form-control"
                    value="00:00"
                    id="Stime"
                    readonly
                  />
                  <span class="input-group-addon">
                    <span class="glyphicon glyphicon-time"></span>
                  </span>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div class="range-input">
                <span class="range-label">تا ساعت *</span>
                <div class="input-group clockpicker">
                  <input
                    type="text"
                    class="form-control"
                    value="23:59"
                    id="Etime"
                    readonly
                  />
                  <span class="input-group-addon">
                    <span class="glyphicon glyphicon-time"></span>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
          (click)="bTankerMood = false"
        >
          بستن
        </button>
        <button type="button" class="btn btn-primary" (click)="ReportStop()">
          تایید
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade rtl"
  id="exampleModal4"
  tabindex="-1"
  aria-labelledby=""
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-clock-o me-2"></i>بازه مد نظر خود را انتخاب کنید
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="chip-group">
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'today')"
            (click)="
              setQuickDate('dataWorkAz', 'today');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            امروز
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'last7')"
            (click)="
              setQuickDate('dataWorkAz', 'last7');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            ۷ روز اخیر
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'monthStart')"
            (click)="
              setQuickDate('dataWorkAz', 'monthStart');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            این ماه
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'last30')"
            (click)="
              setQuickDate('dataWorkAz', 'last30');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            ۳۰ روز اخیر
          </button>
        </div>

        <div class="row g-3">
          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">از تاریخ *</span>
              <form [formGroup]="dataWorkAz">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="date"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
            <div class="range-input mt-2">
              <span class="range-label">از ساعت *</span>
              <div class="input-group clockpicker">
                <input
                  type="text"
                  class="form-control"
                  value="00:00"
                  id="clocks"
                  readonly
                />
                <span class="input-group-addon">
                  <span class="glyphicon glyphicon-time"></span>
                </span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">تا تاریخ *</span>
              <form [formGroup]="dataWorkTa">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="date"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
            <div class="range-input mt-2">
              <span class="range-label">تا ساعت *</span>
              <div class="input-group clockpicker">
                <input
                  type="text"
                  class="form-control"
                  value="23:59"
                  id="clocke"
                  readonly
                />
                <span class="input-group-addon">
                  <span class="glyphicon glyphicon-time"></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer modal-footer-split">
        <button
          type="button"
          class="btn btn-ghost-action"
          (click)="recallDistance()"
          title="محاسبه نرم افزاری فاصله ها"
        >
          <i class="fa fa-refresh" id="recal"></i>
          <span>محاسبه فاصله‌ها</span>
        </button>
        <div class="footer-main-actions">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-bs-dismiss="modal"
          >
            بستن
          </button>
          <button type="button" class="btn btn-primary" (click)="reportWork()">
            تایید
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade rtl"
  id="exampleModal4_1"
  tabindex="-1"
  aria-labelledby=""
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-clock-o me-2"></i>بازه مد نظر خود را انتخاب کنید
        </h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div class="chip-group">
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'today')"
            (click)="
              setQuickDate('dataWorkAz', 'today');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            امروز
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'last7')"
            (click)="
              setQuickDate('dataWorkAz', 'last7');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            ۷ روز اخیر
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'monthStart')"
            (click)="
              setQuickDate('dataWorkAz', 'monthStart');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            این ماه
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'last30')"
            (click)="
              setQuickDate('dataWorkAz', 'last30');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            ۳۰ روز اخیر
          </button>
        </div>

        <div class="row g-3">
          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">از تاریخ *</span>
              <form [formGroup]="dataWorkAz">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="date"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
            <div class="range-input mt-2">
              <span class="range-label">از ساعت *</span>
              <div class="input-group clockpicker">
                <input
                  type="text"
                  class="form-control"
                  value="00:00"
                  id="clocks"
                  readonly
                />
                <span class="input-group-addon">
                  <span class="glyphicon glyphicon-time"></span>
                </span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">تا تاریخ *</span>
              <form [formGroup]="dataWorkTa">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="date"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
            <div class="range-input mt-2">
              <span class="range-label">تا ساعت *</span>
              <div class="input-group clockpicker">
                <input
                  type="text"
                  class="form-control"
                  value="23:59"
                  id="clocke"
                  readonly
                />
                <span class="input-group-addon">
                  <span class="glyphicon glyphicon-time"></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          بستن
        </button>
        <button type="button" class="btn btn-primary" (click)="get_Fueltank()">
          تایید
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade rtl"
  id="exampleModal4_2"
  tabindex="-1"
  aria-labelledby=""
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-clock-o me-2"></i>بازه مد نظر خود را انتخاب کنید
        </h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div class="chip-group">
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'today')"
            (click)="
              setQuickDate('dataWorkAz', 'today');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            امروز
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'last7')"
            (click)="
              setQuickDate('dataWorkAz', 'last7');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            ۷ روز اخیر
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'monthStart')"
            (click)="
              setQuickDate('dataWorkAz', 'monthStart');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            این ماه
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'last30')"
            (click)="
              setQuickDate('dataWorkAz', 'last30');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            ۳۰ روز اخیر
          </button>
        </div>

        <div class="row g-3">
          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">از تاریخ *</span>
              <form [formGroup]="dataWorkAz">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="date"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>

          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">تا تاریخ *</span>
              <form [formGroup]="dataWorkTa">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="date"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          بستن
        </button>
        <button type="button" class="btn btn-primary" (click)="get_Refueling()">
          تایید
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade rtl"
  id="exampleModal4_3"
  tabindex="-1"
  aria-labelledby=""
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-clock-o me-2"></i>بازه مد نظر خود را انتخاب کنید
        </h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div class="chip-group">
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'today')"
            (click)="
              setQuickDate('dataWorkAz', 'today');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            امروز
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'last7')"
            (click)="
              setQuickDate('dataWorkAz', 'last7');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            ۷ روز اخیر
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'monthStart')"
            (click)="
              setQuickDate('dataWorkAz', 'monthStart');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            این ماه
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataWorkAz', 'last30')"
            (click)="
              setQuickDate('dataWorkAz', 'last30');
              setQuickDate('dataWorkTa', 'today')
            "
          >
            ۳۰ روز اخیر
          </button>
        </div>

        <div class="row g-3">
          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">از تاریخ *</span>
              <form [formGroup]="dataWorkAz">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="date"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>

          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">تا تاریخ *</span>
              <form [formGroup]="dataWorkTa">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="date"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          بستن
        </button>
        <button type="button" class="btn btn-primary" (click)="get_Discharge()">
          تایید
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade rtl"
  id="exampleModal4_4"
  tabindex="-1"
  aria-labelledby=""
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-clock-o me-2"></i>بازه مد نظر خود را انتخاب کنید
        </h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div class="chip-group">
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_NetConsumed', 'today')"
            (click)="
              setQuickDate('mdl_NetConsumed', 'today', 'strSDate', 'strEDate')
            "
          >
            امروز
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_NetConsumed', 'last7')"
            (click)="
              setQuickDate('mdl_NetConsumed', 'last7', 'strSDate', 'strEDate')
            "
          >
            ۷ روز اخیر
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_NetConsumed', 'monthStart')"
            (click)="
              setQuickDate(
                'mdl_NetConsumed',
                'monthStart',
                'strSDate',
                'strEDate'
              )
            "
          >
            این ماه
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_NetConsumed', 'last30')"
            (click)="
              setQuickDate('mdl_NetConsumed', 'last30', 'strSDate', 'strEDate')
            "
          >
            ۳۰ روز اخیر
          </button>
        </div>

        <div class="row g-3">
          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">از تاریخ *</span>
              <form [formGroup]="mdl_NetConsumed">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="strSDate"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>

          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">تا تاریخ *</span>
              <form [formGroup]="mdl_NetConsumed">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="strEDate"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          بستن
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="get_NetConsumed()"
        >
          تایید
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade rtl"
  id="exampleModal4_5"
  tabindex="-1"
  aria-labelledby=""
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-clock-o me-2"></i>بازه مد نظر خود را انتخاب کنید
        </h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div class="chip-group">
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_NetConsumed', 'today')"
            (click)="
              setQuickDate('mdl_NetConsumed', 'today', 'strSDate', 'strEDate')
            "
          >
            امروز
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_NetConsumed', 'last7')"
            (click)="
              setQuickDate('mdl_NetConsumed', 'last7', 'strSDate', 'strEDate')
            "
          >
            ۷ روز اخیر
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_NetConsumed', 'monthStart')"
            (click)="
              setQuickDate(
                'mdl_NetConsumed',
                'monthStart',
                'strSDate',
                'strEDate'
              )
            "
          >
            این ماه
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_NetConsumed', 'last30')"
            (click)="
              setQuickDate('mdl_NetConsumed', 'last30', 'strSDate', 'strEDate')
            "
          >
            ۳۰ روز اخیر
          </button>
        </div>

        <div class="row g-3">
          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">از تاریخ *</span>
              <form [formGroup]="mdl_NetConsumed">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="strSDate"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>

          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">تا تاریخ *</span>
              <form [formGroup]="mdl_NetConsumed">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="strEDate"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          بستن
        </button>
        <button type="button" class="btn btn-primary" (click)="sabt2()">
          تایید
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade rtl"
  id="exampleModal4_6"
  tabindex="-1"
  aria-labelledby=""
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-clock-o me-2"></i>بازه مد نظر خود را انتخاب کنید
        </h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div class="chip-group">
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_Consumption', 'today')"
            (click)="
              setQuickDate('mdl_Consumption', 'today', 'strSDate', 'strEDate')
            "
          >
            امروز
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_Consumption', 'last7')"
            (click)="
              setQuickDate('mdl_Consumption', 'last7', 'strSDate', 'strEDate')
            "
          >
            ۷ روز اخیر
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_Consumption', 'monthStart')"
            (click)="
              setQuickDate(
                'mdl_Consumption',
                'monthStart',
                'strSDate',
                'strEDate'
              )
            "
          >
            این ماه
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_Consumption', 'last30')"
            (click)="
              setQuickDate('mdl_Consumption', 'last30', 'strSDate', 'strEDate')
            "
          >
            ۳۰ روز اخیر
          </button>
        </div>

        <div class="row g-3">
          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">از تاریخ *</span>
              <form [formGroup]="mdl_Consumption">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="strSDate"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>

          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">تا تاریخ *</span>
              <form [formGroup]="mdl_Consumption">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="strEDate"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          بستن
        </button>
        <button type="button" class="btn btn-primary" (click)="sabt3()">
          تایید
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade rtl"
  id="exampleModal4_7"
  tabindex="-1"
  aria-labelledby=""
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-clock-o me-2"></i>بازه مد نظر خود را انتخاب کنید
        </h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div class="chip-group">
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_Consumption', 'today')"
            (click)="
              setQuickDate('mdl_Consumption', 'today', 'strSDate', 'strEDate')
            "
          >
            امروز
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_Consumption', 'last7')"
            (click)="
              setQuickDate('mdl_Consumption', 'last7', 'strSDate', 'strEDate')
            "
          >
            ۷ روز اخیر
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_Consumption', 'monthStart')"
            (click)="
              setQuickDate(
                'mdl_Consumption',
                'monthStart',
                'strSDate',
                'strEDate'
              )
            "
          >
            این ماه
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('mdl_Consumption', 'last30')"
            (click)="
              setQuickDate('mdl_Consumption', 'last30', 'strSDate', 'strEDate')
            "
          >
            ۳۰ روز اخیر
          </button>
        </div>

        <div class="row g-3">
          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">از تاریخ *</span>
              <form [formGroup]="mdl_Consumption">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="strSDate"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>

          <div class="col-md-6">
            <div class="range-input">
              <span class="range-label">تا تاریخ *</span>
              <form [formGroup]="mdl_Consumption">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="strEDate"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          بستن
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="submit_Flowtrend()"
        >
          تایید
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade rtl"
  id="exampleModal5"
  tabindex="-1"
  aria-labelledby=""
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-clock-o me-2"></i>بازه مد نظر خود را انتخاب کنید
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="chip-group">
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataAz', 'today')"
            (click)="
              setQuickDate('dataAz', 'today'); setQuickDate('dataTa', 'today')
            "
          >
            امروز
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataAz', 'last7')"
            (click)="
              setQuickDate('dataAz', 'last7'); setQuickDate('dataTa', 'today')
            "
          >
            ۷ روز اخیر
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataAz', 'monthStart')"
            (click)="
              setQuickDate('dataAz', 'monthStart');
              setQuickDate('dataTa', 'today')
            "
          >
            این ماه
          </button>
          <button
            class="chip"
            type="button"
            [class.active]="isChipActive('dataAz', 'last30')"
            (click)="
              setQuickDate('dataAz', 'last30'); setQuickDate('dataTa', 'today')
            "
          >
            ۳۰ روز اخیر
          </button>
        </div>

        <div class="row g-3">
          <div [ngClass]="api == '7' ? 'col-md-4' : 'col-md-6'">
            <div class="range-input">
              <span class="range-label">از تاریخ *</span>
              <form [formGroup]="dataAz">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="date"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>
          <div [ngClass]="api == '7' ? 'col-md-4' : 'col-md-6'">
            <div class="range-input">
              <span class="range-label">تا تاریخ *</span>
              <form [formGroup]="dataTa">
                <ng-persian-datepicker
                  [uiTheme]="'gray'"
                  [timeEnable]="false"
                  [dateGregorianFormat]="'YYYY/MM/DD'"
                  [dateFormat]="'jYYYY/jMM/jDD'"
                >
                  <input
                    type="text"
                    formControlName="date"
                    class="form-control text-end"
                    readonly
                  />
                </ng-persian-datepicker>
              </form>
            </div>
          </div>
          <div class="col-md-4" *ngIf="api == '7'">
            <div class="range-input">
              <span class="range-label">نوع واقعه</span>
              <select class="form-control" id="deviceEvents">
                <option value="-1">همه موارد</option>
                <option
                  *ngFor="let item of deviceEvents"
                  value="{{ item.tiDeviceEventsType }}"
                >
                  {{ item.strComment }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          بستن
        </button>
        <button type="button" class="btn btn-primary" (click)="sabtdata()">
          تایید
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade rtl"
  id="exampleModal6"
  tabindex="-1"
  aria-labelledby=""
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fa fa-paper-plane me-2"></i>ارسال پیام
        </h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div class="btn-group-toggle" role="group">
          <button
            class="btn"
            type="button"
            [class.active]="isCommandList"
            (click)="updateCommand(true)"
          >
            لیست فرامین
          </button>
          <button
            class="btn"
            type="button"
            [class.active]="!isCommandList"
            (click)="updateCommand(false)"
          >
            پاسخ فرمان های ارسالی
          </button>
        </div>

        <div class="filter-bar">
          <input
            type="text"
            class="form-control"
            placeholder="جستجو کنید ..."
            (keyup)="filter_list($event.target)"
          />
          <span class="filter-icon"><i class="fa fa-search"></i></span>
        </div>

        <div *ngIf="isCommandList" class="table-wrap">
          <table class="table table-hover align-middle mb-0" id="excel-list">
            <thead>
              <tr class="text-center">
                <th scope="col">#</th>
                <th scope="col">عملیات</th>
                <th scope="col">نوع</th>
                <th scope="col">عنوان</th>
              </tr>
            </thead>

            <tbody>
              <tr
                class="text-center"
                *ngFor="let item of lst_CommandList; let i = index"
              >
                <td>{{ i + 1 | faNum }}</td>

                <td
                  (click)="
                    item.tiCommandType == 0 ? sendSMS(item) : sendGPRS(item)
                  "
                >
                  <i
                    class="fa fa-paper-plane fa-lg pointer text-primary"
                    title="ارسال"
                  ></i>
                </td>

                <td>{{ item.strCommandType | faNum }}</td>

                <td>{{ item.strTitle | faNum }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-container *ngIf="!isCommandList">
          <div class="d-flex mb-2" *ngIf="lstChecked.length">
            <button
              class="btn btn-danger btn-sm rounded-pill px-3"
              (click)="removeSelected()"
            >
              حذف
            </button>
          </div>

          <div class="list-wrap">
            <div class="list-container" id="list-container">
              <div
                *ngFor="let item of lst_CommandList"
                class="response-item"
                [class.is-selected]="isSelected(item.id)"
                (click)="setCheckBox(!isSelected(item.id), item)"
              >
                <div class="d-flex align-items-start gap-2">
                  <input
                    type="checkbox"
                    class="form-check-input mt-1"
                    (change)="setCheckBox($event.target.checked, item)"
                    [checked]="isSelected(item.id)"
                  />

                  <div class="flex-grow-1">
                    <p class="mb-0 text-end" dir="ltr">
                      <small> {{ item.result_value }} </small>

                      <span
                        class="text-muted pointer mx-2"
                        (click)="copyToClipboard(item.result_value)"
                      >
                        <i class="fa fa-clipboard" aria-hidden="true"></i>
                      </span>
                    </p>

                    <p class="mb-0 text-muted">
                      <small> {{ item.Column1 | faNum }} </small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          بستن
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade rtl"
  id="documentModal"
  tabindex="-1"
  aria-labelledby=""
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{
            bDocumentMode == "viewMode"
              ? documentModel.get("strEvidenceType_strComment")?.value +
                " ( تاریخ اعتبار : " +
                (documentModel.get("strExpireDate")?.value | faNum) +
                " ) "
              : " اسناد و مدارک "
          }}
        </h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="dir modal-body">
        <ng-container
          *ngIf="
            bDocumentMode == 'documentMode' || bDocumentMode == 'deleteMode'
          "
        >
          <div class="row gx-3 px-2 gy-2">
            <div class="col-12 col-md-9 p-2">
              <select
                (change)="documentOperation('', '', $event)"
                class="form-control"
                id="list_documentsType"
              >
                <option class="text-danger fw-bold text-center" disabled>
                  جستجو بر اساس نوع نوع مدرک
                </option>

                <option value="-1">همه مدارک</option>

                <option
                  *ngFor="let item of list_documentsType"
                  value="{{ item.tiEvidenceType }}"
                >
                  {{ item.strComment }}
                </option>
              </select>
            </div>

            <div
              *ngIf="acssess.bEvidenceDriver_Edit"
              class="col-12 col-md-3 p-2"
            >
              <button
                type="button"
                class="btn btn-success w-100"
                (click)="documentOperation('', '', 'search')"
              >
                سند جدید
              </button>
            </div>

            <div
              class="album-container row gx-2 gy-2 gy-md-0 w-100 border border-2 p-2"
            >
              <div
                *ngFor="let item of list_documents_Filter; let i = index"
                class="document-box pointer col-12 col-md-4 p-2"
              >
                <div
                  class="position-relative p-2 border border-2 rounded w-100 h-100"
                >
                  <img
                    src="{{ 'data:image/jpeg;base64,' + item.strImage }}"
                    alt="{{ item.strEvidenceType_strComment }}"
                  />

                  <div class="tag-document w-100">
                    <i
                      class="fa fa-trash border border-2 border-dark bg-th-white text-danger p-2 px-2"
                      (click)="
                        bDocumentMode = 'deleteMode'; documentOperation(item, i)
                      "
                      aria-hidden="true"
                    ></i>

                    <i
                      *ngIf="acssess.bEvidenceDriver_Edit"
                      class="fa fa-pencil-square border border-2 border-dark bg-th-white text-primary p-2 px-2 mx-1"
                      (click)="editDocument(item, i)"
                      aria-hidden="true"
                    ></i>

                    <i
                      class="fa fa-eye border border-2 border-dark bg-th-white text-success p-2 px-2"
                      (click)="
                        bDocumentMode = 'viewMode'; documentOperation(item, i)
                      "
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
              </div>

              <div
                *ngIf="!list_documents_Filter.length"
                class="text-center p-2"
              >
                موردی یافت نشد
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container
          *ngIf="bDocumentMode == 'addMode' || bDocumentMode == 'editMode'"
        >
          <form [formGroup]="documentModel" class="row gx-3 px-2 gy-2">
            <div class="col-12 col-md-6">
              <label> نوع مدرک </label>

              <select
                formControlName="tiEvidenceType"
                class="form-control"
                id="list_documentsType"
              >
                <option
                  *ngFor="let item of list_documentsType"
                  value="{{ item.tiEvidenceType }}"
                >
                  {{ item.strComment }}
                </option>
              </select>
            </div>

            <div class="col-12 col-md-6">
              <label> تاریخ پایان اعتبار </label>

              <ng-persian-datepicker
                [timeEnable]="false"
                [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateFormat]="'jYYYY/jMM/jDD'"
              >
                <input
                  type="text"
                  formControlName="strExpireDate"
                  class="form-control text-end"
                />
              </ng-persian-datepicker>
            </div>

            <div
              (click)="fileInput.click()"
              class="image-uploader-container col-12 border border-2 p-2"
            >
              <img
                src="{{
                  documentModel.get('strImage').value != ''
                    ? 'data:image/jpeg;base64,' +
                      documentModel.get('strImage').value
                    : '../../../assets/Img/gallery.jpg'
                }}"
                alt=""
              />

              <p>تصویر خود را آپلود کنید</p>

              <input
                hidden
                type="file"
                #fileInput
                (change)="onFileInput($event.target.files[0])"
              />
            </div>
          </form>
        </ng-container>

        <ng-container *ngIf="bDocumentMode == 'viewMode'">
          <div class="w-100 h-100 col-12 border border-2 p-2">
            <img
              class="w-100 h-100"
              src="{{
                'data:image/jpeg;base64,' + documentModel.get('strImage').value
              }}"
              alt=""
            />
          </div>
        </ng-container>
      </div>

      <div dir="ltr" class="modal-footer">
        <button
          *ngIf="bDocumentMode == 'addMode' || bDocumentMode == 'editMode'"
          type="button"
          class="px-4 btn"
          [ngClass]="bDocumentMode == 'addMode' ? 'btn-success' : 'btn-primary'"
          (click)="documentOperation()"
        >
          {{ bDocumentMode == "addMode" ? "ذخیره" : "ویرایش" }}
        </button>

        <button
          type="button"
          class="px-3 btn btn-danger"
          (click)="
            bDocumentMode == 'addMode' ||
            bDocumentMode == 'editMode' ||
            bDocumentMode == 'viewMode'
              ? (bDocumentMode = 'documentMode')
              : ''
          "
          [attr.data-bs-dismiss]="
            bDocumentMode == 'documentMode' ? 'modal' : null
          "
        >
          {{
            bDocumentMode == "documentMode" || bDocumentMode == "deleteMode"
              ? "بستن"
              : "بازگشت"
          }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade rtl"
  id="NetConsumed_Modal"
  tabindex="-1"
  aria-labelledby=""
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">سوخت خالص مصرفی</h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body row gx-0 gy-0">
        <div class="position-relative col-12 col-md-4 p-2">
          <p class="mb-0">
            <span class="fw-bold text-muted"> نام خودرو : </span>

            <span class=""> {{ obj_NetConsumed?.strFullName }} </span>
          </p>
        </div>

        <div class="position-relative col-12 col-md-4 p-2">
          <p class="mb-0">
            <span class="fw-bold text-muted"> تاریخ شروع : </span>

            <span class=""> {{ obj_NetConsumed?.strSDate | faNum }} </span>
          </p>
        </div>

        <div class="position-relative col-12 col-md-4 p-2">
          <p class="mb-0">
            <span class="fw-bold text-muted"> تاریخ پایان : </span>

            <span class=""> {{ obj_NetConsumed?.strEDate | faNum }} </span>
          </p>
        </div>

        <div class="position-relative col-12 col-md-4 p-2">
          <p class="mb-0">
            <span class="fw-bold text-muted"> مقدار سوختگیری : </span>

            <span class="">
              {{ obj_NetConsumed?.TotalRefueling | faNum }} لیتر
            </span>
          </p>
        </div>

        <div class="position-relative col-12 col-md-4 p-2">
          <p class="mb-0">
            <span class="fw-bold text-muted"> مقدار برداشت مشکوک : </span>

            <span class="">
              {{ obj_NetConsumed?.TotalHarvesting | faNum }} لیتر
            </span>
          </p>
        </div>

        <div class="position-relative col-12 col-md-4 p-2">
          <p class="mb-0">
            <span class="fw-bold text-muted"> موجودی باک : </span>

            <span class="">
              {{ obj_NetConsumed?.EndTankValue | faNum }} لیتر
            </span>
          </p>
        </div>

        <div class="position-relative col-12 col-md-4 p-2">
          <p class="mb-0">
            <span class="fw-bold text-muted"> مصرف : </span>

            <span class="">
              {{ obj_NetConsumed?.RealConsumption.toFixed(2) | faNum }} لیتر
            </span>
          </p>
        </div>
      </div>

      <div dir="ltr" class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          بستن
        </button>
      </div>
    </div>
  </div>
</div>

<app-operation-modal #operationModal
    [car]="car"
    [acssess]="acssess"
    [carId]="Id">
  </app-operation-modal>

<app-report-modal #reportModal
    [car]="car"
    [acssess]="acssess"
    [carId]="Id"
    (apiChange)="api = $event"
    (tankerMoodChange)="bTankerMood = $event"
    (tankerRouteChange)="bTankerRoute = $event">
  </app-report-modal>




